module.exports = __webpack_public_path__ + "static/media/france.9664c370.svg";